import { showLog } from "../helper/utility";

export const EVENTS = {
  VIEW_CONTENT: "ViewContent",
  SEARCH: "Search",
  ADD_TO_CART: "AddToCart",
  INITIATE_CHECKOUT: "InitiateCheckout",
  ADD_PAYMENT_INFO: "AddPaymentInfo",
  PURCHASE: "Purchase",
  LEAD: "Lead",
} as const;

export type AnalyticsEvent = typeof EVENTS[keyof typeof EVENTS];

export interface AnalyticsData {
  [key: string]: unknown;
}

/**
 * Trigger analytics event (Facebook Pixel, etc.)
 * @param {AnalyticsEvent} event - one of EVENTS
 * @param {AnalyticsData} data - optional event data
 */
export const trackEvent = (event: AnalyticsEvent, data: AnalyticsData = {}): void => {
  if (!Object.values(EVENTS).includes(event)) {
    showLog(`Analytics event "${event}" is not defined.`);
    return;
  }

  showLog(`Event triggered: ${event}`, data);

  // Facebook Pixel integration
  if (typeof window !== "undefined" && (window as any).fbq) {
    (window as any).fbq("track", event, data);
  } else {
    showLog("Facebook Pixel not loaded.");
  }

  // Add other analytics providers here if needed
  // Example: Google Analytics (gtag)
  // if (typeof window !== "undefined" && (window as any).gtag) {
  //   (window as any).gtag("event", event, data);
  // }
};
